import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, InsertLinkOutlined } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { v4 } from "uuid";
import { DeleteSvgIcon, DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../assets/customIcons";
import { CrossCircleGray, SearchIconGray } from "../../../assets/images";
import { MuiIconButton, MuiStack } from "../../../builderPackage/components";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { showNotification } from "../../../redux/commonSlice";
import { useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate } from "../../../utils/utils";
import { stockAdjustmentCreate, warehouseListGet } from "../apiCall";
import StockAdjustmentPartDataGrid from "../components/stockAdjustmentPartDataGrid";
import { StockAdjustmentKeys, StockAdjustmentMandatoryFields } from "../entity";
export var CreteStockAdjustment = function () {
    var _crud$profilePersonal, _getLocalStorageItem, _getLocalStorageItem2;
    var navigate = useNavigate();
    var crud = useAppSelector(function (state) { return state.crud; });
    var dispatch = useDispatch();
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var profileDetails = crud === null || crud === void 0 || (_crud$profilePersonal = crud.profilePersonalDetails) === null || _crud$profilePersonal === void 0 ? void 0 : _crud$profilePersonal.data;
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var warehouseList = function (params) { return warehouseListGet(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            TenantId: UserOrganization
        })
    })); };
    var tab1 = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            title: 'Basic Details',
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'Warehouse',
                    label: 'Warehouse',
                    getListData: warehouseList,
                    apiKey: StockAdjustmentKeys.warehouse,
                    required: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'RequestedBy',
                    label: 'Requested By',
                    value: "".concat(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.GivenName, " ").concat(profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.FamilyName),
                    multiline: true,
                    minRows: 1,
                    disabled: true
                }]
        }, {
            type: FormItemTypes.Custom,
            name: "StockAdjustmentRequisitionDetail",
            element: StockAdjustmentPartDataGrid,
            columnSize: 12,
            validator: function (rows, state) {
                var error = undefined;
                if (!(rows !== null && rows !== void 0 && rows.length)) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: 'Please add part details',
                        type: "error"
                    }));
                    return 'Please add part details';
                }
                rows.find(function (r) {
                    var errorField = Object.keys(StockAdjustmentMandatoryFields).find(function (field) { return typeof r[field] !== 'number' && typeof r[field] !== 'boolean' && !r[field]; });
                    if (errorField) {
                        error = {
                            id: v4(),
                            rowId: r.id,
                            field: StockAdjustmentMandatoryFields[errorField],
                            message: 'This field is required',
                            value: r[errorField]
                        };
                        return true;
                    }
                    if (r.AdjustedQuantity === 0) {
                        error = {
                            id: v4(),
                            rowId: r.id,
                            field: 'AdjustedQuantity',
                            message: 'Adjusted Quantity cannot be zero',
                            value: r.AdjustedQuantity
                        };
                        return true;
                    }
                    return false;
                });
                return error;
            }
        }];
    var tabs = [{
            id: '0',
            label: 'General',
            elements: tab1
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'pageHeader',
            columnSize: 12,
            justifyContent: 'space-between',
            alignItems: 'center',
            spacing: 0,
            columnSpacing: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: 'back',
                    size: 'small',
                    onClick: function () { return navigate('/stockAdjustment'); },
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small"
                    }),
                    columnSize: 0
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Create stock adjustment',
                    columnSize: 0,
                    variant: 'h1',
                    noWrap: true
                }, mode !== "add" ? {
                    type: FormItemTypes.Custom,
                    name: '',
                    columnSize: 0,
                    element: function (props) {
                        var _props$value;
                        return /*#__PURE__*/ React.createElement(Chip, {
                            label: props === null || props === void 0 || (_props$value = props.value) === null || _props$value === void 0 || (_props$value = _props$value.Status) === null || _props$value === void 0 ? void 0 : _props$value.Name,
                            size: "small",
                            variant: "outlined",
                            sx: {
                                borderRadius: 2,
                                px: 1,
                                fontWeight: 'bold'
                            },
                            icon: /*#__PURE__*/ React.createElement(Box, {
                                height: 8,
                                width: 8,
                                borderRadius: 10,
                                bgcolor: "gray"
                            })
                        });
                    }
                } : null, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 0,
                    elements: mode !== "edit" ? [] : [{
                            type: FormItemTypes.Typography,
                            name: 'DocumentCode',
                            label: 'DOC NO: ',
                            columnSize: 0,
                            fontWeight: 400,
                            fontSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'CreatedOn',
                            label: 'DATE: ',
                            valueGetter: function (formData) {
                                return dateFormate(formData === null || formData === void 0 ? void 0 : formData.CreatedOn);
                            },
                            columnSize: 0,
                            fontWeight: 400,
                            fontSize: 12
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'flex-end',
            bgcolor: '#EFF2F5',
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'SearchWithOptions',
                    setFieldProps: function (formValues, currValue) {
                        if (currValue) {
                            return {
                                type: this.type,
                                InputProps: {
                                    startAdornment: /*#__PURE__*/ React.createElement(MuiStack, {
                                        p: 1
                                    }, /*#__PURE__*/ React.createElement("img", {
                                        src: SearchIconGray,
                                        id: "Search-Icon-Gray"
                                    })),
                                    endAdornment: /*#__PURE__*/ React.createElement(MuiIconButton, {
                                        onClick: function (e) { },
                                        id: "Mui-Icon-Image-Button"
                                    }, /*#__PURE__*/ React.createElement("img", {
                                        src: CrossCircleGray,
                                        id: "Cross-Circle-Gray"
                                    }))
                                }
                            };
                        }
                        else {
                            return {
                                type: this.type,
                                InputProps: {
                                    startAdornment: /*#__PURE__*/ React.createElement(MuiStack, {
                                        p: 1
                                    }, /*#__PURE__*/ React.createElement("img", {
                                        src: SearchIconGray,
                                        id: "Search-Icon-Gray"
                                    }))
                                }
                            };
                        }
                    },
                    placeholder: 'Search customer by VIN, reg no, job card no, name',
                    columnSize: 4
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'flex-end',
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'links',
                            children: /*#__PURE__*/ React.createElement(Typography, {
                                display: {
                                    sm: 'none',
                                    md: 'flex'
                                }
                            }, 'Quick Links'),
                            columnSize: 0,
                            variant: 'text',
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            sx: {
                                background: 'none',
                                justifyContent: 'center'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'download',
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary',
                            sx: {
                                px: 1
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'share',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary',
                            sx: {
                                px: 1
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'print',
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary',
                            sx: {
                                px: 1
                            }
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 0,
                            height: '100%',
                            width: '2px',
                            bgcolor: 'rgba(0,0,0,0.1)',
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: 'reset',
                            children: /*#__PURE__*/ React.createElement(DeleteSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: 'draft',
                            children: 'Save as draft',
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: 'submit',
                            children: 'Save',
                            columnSize: 0,
                            variant: 'contained',
                            color: 'primary',
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: "Tabs",
            label: "",
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            variant: 'scrollable',
            columnSize: 12,
            tabPanelProps: {
                sx: {
                    px: {
                        xs: 2,
                        sm: 2.5,
                        md: 3
                    }
                }
            },
            sx: {
                paddingX: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                },
                gap: 2.5
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }];
    var handleOnFormClose = function () {
        dispatch(showNotification({
            isOpen: true,
            message: "Stock Adjustment Created Successfully",
            type: "success"
        }));
        navigate("/stockAdjustment");
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0,
        createFormAPI: stockAdjustmentCreate,
        createKey: StockAdjustmentKeys.create,
        createRequest: {
            TenantId: UserOrganization,
            ParentTenantId: UserParentOrganization,
            AssignTo: profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.IdentityId
        },
        onClose: handleOnFormClose
    }));
};
